'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CalChinese = require('date-chinese');

var CalEvent = require('./CalEvent');

var CalDate = require('caldate');

var Chinese = /*#__PURE__*/function (_CalEvent) {
  _inherits(Chinese, _CalEvent);

  var _super = _createSuper(Chinese);

  /**
   * @param {object} [opts]
   */
  function Chinese(opts) {
    var _this;

    _classCallCheck(this, Chinese);

    opts = opts || {};
    _this = _super.call(this, opts);

    switch (opts.fn) {
      case 'chinese':
        _this.cal = new CalChinese.CalendarChinese();
        break;

      case 'korean':
        _this.cal = new CalChinese.CalendarKorean();
        break;

      case 'vietnamese':
        _this.cal = new CalChinese.CalendarVietnamese();
        break;
    }

    return _this;
  }

  _createClass(Chinese, [{
    key: "inYear",
    value: function inYear(year) {
      var d;
      var jde;
      var date;
      var opts = this.opts;

      if (opts.solarterm) {
        jde = this.cal.solarTerm(opts.solarterm, year);
        date = this.cal.fromJDE(jde).toGregorian();
        d = new CalDate(date).setOffset(opts.day - 1);
      } else {
        this.cal.set(opts.cycle, opts.year, opts.month, opts.leapMonth, opts.day);
        jde = this.cal.toJDE(year);
        date = this.cal.fromJDE(jde).toGregorian();
        d = new CalDate(date);
      }

      this.dates.push(d);
      return this;
    }
  }]);

  return Chinese;
}(CalEvent);

module.exports = Chinese;